import React from 'react';
import styled from '@emotion/styled';
import validation, { isRequired, isValidUrl } from '../utils/validation';
import InputField from './InputField';
import TargetField from './TargetField';

const HeightContainer = styled('div')`
  min-height: 75px;
`;

const LinkPrompt = ({ formData }) => {
  return (
    <HeightContainer>
      <InputField
        name="href"
        required={true}
        label="Location"
        autoFocus={true}
        validate={validation(isRequired, isValidUrl)}
        formData={formData}
      />
      <InputField name="title" type="string" label="Title" formData={formData} />
      <TargetField
        name="target"
        type="checkbox"
        label="Open in a new tab?"
        formData={formData}
        format={(value) => value === '_blank'}
        parse={(value) => value === true ? '_blank' : '_self'}
      />
    </HeightContainer>
  );
};


export default LinkPrompt;



// WEBPACK FOOTER //
// ./app/javascript/client/editor-ui/prompts/LinkPrompt.jsx